import { useEffect, useState } from 'react';
import type { StrategicInsightsData, StrategicInsightsFilters } from '../../services/api';
import { apiService } from '../../services/api';

export const useFetchInsights = (filters: StrategicInsightsFilters) => {
  const [data, setData] = useState<StrategicInsightsData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    const fetchInsights = async () => {
      try {
        setLoading(true);
        setError(null);
        // Call the API service
        const response = await apiService.getStrategicInsights(filters);
        if (mounted) {
          setData(
            (response as unknown as { data: StrategicInsightsData }).data ||
              (response as unknown as StrategicInsightsData)
          );
        }
      } catch (err: unknown) {
        if (mounted) {
          setError(err instanceof Error ? err.message : 'Failed to fetch insights');
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchInsights();
    return () => {
      mounted = false;
    };
  }, [filters]);

  return { data, loading, error };
};
